import CardSkeleton from './card-skeleton';

export default CardSkeleton;
